<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
      <!-- <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template> -->
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="withdraw_money"  :placeholder="$t('q14')" />
      <van-field v-model="paypassword"  :placeholder="$t('q15')" />
    </van-cell-group>
    <div class="p_c"><span>{{$t("my.balance")}}：</span>
      <span class="number">{{ this.userInfo.money }}{{$t("reservation.ge")}}</span></div>
    <div class="p_c">{{$t('q16')}}：{{ this.userInfo.name }}</div>
    <div class="hang_p_c">
      <input type="radio" name="bank" value="wallet" v-model="selectBankType">
      {{$t('withdraw.wallet_address')}}：{{ bankInfo.walletAddress || $t('withdraw.not_bound') }}
    </div>
    <div class="hang_p_c">
      <input type="radio" name="bank" value="bank" v-model="selectBankType">
      {{$t("setting.bank_account")}}：{{ bankInfo2.bankid || $t('withdraw.not_bound') }}
    </div>
    
    <div class="sub-btn" @click="doWithdraw()">
      {{$t('q18')}}
    </div>
    <div class="shuoming">
      <div class="l_p q1">{{$t('q19')}}：</div>
      <div class="l_p">1、{{$t('q20')}}{{ getCurrentLevelWithdrawMax() }}{{$t("reservation.ge")}}</div>
      <div class="l_p">2、{{$t('q21')}}{{ getCurrentLevelWithdrawMin() }}{{$t("reservation.ge")}}</div>
      <div class="l_p">3、{{$t('q22')}}</div>
      <div class="l_p">4、{{$t('q23')}}</div>
    </div>
    <!-- 原注释代码保持不变 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      money:"",
      paypassword:"",
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{},
      bankInfo:{},
      bankInfo2:{},
      currentLevel: null,
      selectBankType:'wallet'
    };
  },
  methods: {
    // 获取当前用户等级信息
    getCurrentLevel() {
      if (!this.userInfo.all_levels || !this.userInfo.vip) return null;
      return this.userInfo.all_levels.find(level => level.name === this.userInfo.vip);
    },

    // 获取当前等级最大提现金额
    getCurrentLevelWithdrawMax() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_max_amount : '0';
    },

    // 获取当前等级最小提现金额
    getCurrentLevelWithdrawMin() {
      return '0';
    },

    // 获取当前等级最小完成单数
    getCurrentLevelMinCompletedOrders() {
      const level = this.getCurrentLevel();
      return level ? level.min_completed_orders : 0;
    },

    // 获取当前等级提现手续费
    getCurrentLevelWithdrawFee() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_fee : '0';
    },

    // 获取当前等级提现次数
    getCurrentLevelWithdrawCount() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_count : 0;
    },

    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank',
        data:{
          type:'wallet'
        }
      }).then(res=>{
        if(res.code === 200){
          // 后端返回的 info 结构为 { walletAddress, username }
          this.bankInfo = res.data.info || {};
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
      this.$http({
        method: 'get',
        url: 'user_get_bank',
        data:{
          type:'bank'
        }
      }).then(res=>{
        if(res.code === 200){
          this.bankInfo2 = res.data.info || {};
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
          console.log('用户信息:', this.userInfo);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          console.log(res.data,"res.data---119")
          this.withdrawRole = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw(){
      if(this.selectBankType === 'wallet'&&!this.bankInfo.walletAddress){
        this.$toast(this.$t("withdraw.bind_wallet_first"));
        return false;
      }
      if(this.selectBankType === 'bank'&&!this.bankInfo2.bankid){
        this.$toast(this.$t("withdraw.bind_bank_first"));
        return false;
      }

      if(!this.paypassword){
        this.$toast(this.$t('q24'));
        return false;
      }
      
      if(!this.withdraw_money || this.withdraw_money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }

      // 验证提现条件
      const amount = parseFloat(this.withdraw_money);
      const minAmount = parseFloat(this.getCurrentLevelWithdrawMin());
      const maxAmount = parseFloat(this.getCurrentLevelWithdrawMax().replace(',', ''));
      const balance = parseFloat(this.userInfo.money);
      const todayCompleted = this.userInfo.daily_order_limit ? this.userInfo.daily_order_limit.today_completed : 0;
      const minCompletedOrders = this.getCurrentLevelMinCompletedOrders();

      if (amount < minAmount) {
        this.$toast(`${this.$t('withdraw.min_amount_error')} ${minAmount}`);
        return false;
      }

      if (amount > maxAmount) {
        this.$toast(`${this.$t('withdraw.max_amount_error')} ${maxAmount}`);
        return false;
      }

      if (amount > balance) {
        this.$toast(this.$t('withdraw.insufficient_balance'));
        return false;
      }

      if (todayCompleted < minCompletedOrders) {
        this.$toast(`${this.$t('withdraw.min_orders_error')} ${minCompletedOrders}`);
        return false;
      }

      this.$http({
        method: 'post',
        data:{money:this.withdraw_money,paypassword:this.paypassword,type:this.selectBankType},
        url: 'user_set_withdraw'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.getUserInfo();
          this.getUserWithdrawRole();
          this.withdraw_money = '';
          this.paypassword = '';
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },
  mounted(){
    this.getUserBankInfo();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.p_c{
  color: #fff;
  padding:0 30px 20px;
  font-size: 28px;
}
.hang_p_c{
  padding:0 0px 20px;
  border-bottom: 1px solid #c5a081;
  margin: 0 20px;
  color: #c5a081;
  font-size: 28px;
}
.sub-btn{
  background: linear-gradient(#fde3ca, #e7b486);
  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 40px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.shuoming{
  background: #2e2e2e;
  color: #c1c1c1;
  padding: 40px 36px;
  .l_p{
    font-size: 26px;
    margin-top: 16px;
    &.q1{
      font-size: 30px;
    }
  }
}
/deep/ .van-field__label{
  color: #ccc;
}
.van-cell-group{
  background-color: transparent;
  padding: 30px 0;
  &:after{
    display: none;
  }
}
.van-cell{
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  &+.van-cell{
    margin-top: 30px;
  }
  
  /deep/ .van-field__control{
    color: #f3c7a2;
  }
  &:after{
    display: none;
  }
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
